import React, { useEffect } from 'react';
import { AssistantContainerBaseConfig } from '../../../base';
import { InterviewUrlParamSchema } from '../../../interviewSchema';
import {
    AssistantLayoutController,
    AssistantLayoutLoader,
    AssistantLayoutStateProvider,
} from './interviewLayoutInterface';
import {
    AssistantLayoutContainerProps,
    AssistantLayoutViewProps,
} from './interviewLayoutProps';
import { useLocation, useNavigate } from 'react-router';
import { useColorMode } from '@chakra-ui/react';
import { useLocalStorage } from 'react-use';

export function createAssistantLayoutContainer(
    config: AssistantContainerBaseConfig,
    states: AssistantLayoutStateProvider,
    loader: AssistantLayoutLoader,
    controller: AssistantLayoutController,
    View: {
        Desktop: React.FC<AssistantLayoutViewProps>;
        Mobile: React.FC<AssistantLayoutViewProps>;
    }
): React.FC<AssistantLayoutContainerProps> {
    const {
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
        context: {
            root: { useContext },
        },
    } = config;
    const { Desktop: DesktopView, Mobile: MobileView } = View;
    return ({ children, ...containerProps }) => {
        const options = useOptions(InterviewUrlParamSchema);
        const state = states.useState();
        const navigate = useNavigate();
        const context = useContext();
        const data = loader.useLoad(context, containerProps);
        const props = controller.useProps(context, data, {
            ...options,
            // returnPath: options.returnPath ?? null,
            detail: state.detail,
            isScrollable: containerProps.isScrollable,
            navigation: {
                navigate,
                location: useLocation(),
            },
            onBack() {
                if (options.returnPath) {
                    navigate(options.returnPath);
                    return;
                }
                return navigate(config.navigation.home.path);
            },
        });

        // NOTE there's a bug that breaks the public chakra API for changing and setting default theme
        const { colorMode, toggleColorMode } = useColorMode();
        React.useEffect(() => {
            if (colorMode === 'light') {
                toggleColorMode();
            }
            // this is a hack to fix this issue
            // https://github.com/chakra-ui/chakra-ui/issues/5925
            if (
                localStorage.getItem('chakra-ui-color-mode') === 'light' ||
                !localStorage.getItem('chakra-ui-color-mode')
            ) {
                localStorage.setItem('chakra-ui-color-mode', 'dark');
            }
        }, []);

        if (props.browser.mode === 'mobile') {
            return (
                <MobileView {...containerProps} {...props}>
                    {children}
                </MobileView>
            );
        }
        return (
            <DesktopView {...containerProps} {...props}>
                {children}
            </DesktopView>
        );
    };
}
